<template>
  <div class="TeamStatsCard content shadow">
      <div class="stats-heading">WIN RATE</div>
      <div v-if="!(team.teamStats == null)" class="stats">{{Math.round(team.teamStats.avgWinRate)}}%</div>
      <div v-else class="stats">N/A</div>
      <div class="stats-heading">RANK</div>
      <div v-if="!(team.teamStats == null)" class="stats">{{Math.round(team.teamStats.avgRank)}}</div>
      <div v-else class="stats">N/A</div>
      <div class="stats-heading">DAMAGE DONE</div>
      <div v-if="!(team.teamStats == null)" class="stats">{{Math.round(team.teamStats.avgDmgDone)}}</div>
      <div v-else class="stats">N/A</div>
      <div class="stats-heading">ELIMINATIONS</div>
      <div v-if="!(team.teamStats == null)" class="stats">{{Math.round(team.teamStats.avgEliminations)}}</div>
      <div v-else class="stats">N/A</div>
      <div class="stats-heading">HEALING DONE</div>
      <div v-if="!(team.teamStats == null)" class="stats">{{Math.round(team.teamStats.avgHealingDone)}}</div>
      <div v-else class="stats">N/A</div>
      
  </div>
</template>

<script>
export default {
  name: 'TeamStatsCard',
  props: ["team"],
}
//{ "avgRank": 4157, "avgDmgDone": 11601.713043478261, "avgEliminations": 26.94782608695652, "avgHealingDone": 53.982608695652175, "avgWinRate": 53.91 }
</script>

<style scoped>
.TeamStatsCard{
    background-color: #33333333;
    text-align: center;
    width: -webkit-fill-available;
    padding: 10px;
}
.stats-heading{
  color: orange;
  margin-top: 10px;
  font-size: 30px;
}
.stats{
  color: rgb(255, 255, 255);
  font-size: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/TeamStatsCard.vue